import React, { useState } from "react";
import {Button, Modal, Spinner} from "react-bootstrap";
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { far } from "@fortawesome/pro-regular-svg-icons";
import { defineMessages, injectIntl } from "react-intl";
import useUserAccount from "../hooks/useUserAccount";
import AlertDialog from "./AlertDialog";

const messages = defineMessages({
    title: {
        id: "Poista liitetty sähköposti",
        defaultMessage: "Poista liitetty sähköposti"
    },
    confirmationText: {
        id: "Oletko varma, että haluat poistaan liitetyn sähköpostin %email%?",
        defaultMessage: "Oletko varma, että haluat poistaan liitetyn sähköpostin %email%?"
    },
    goBack: {
        id: "Palaa takaisin",
        defaultMessage: "Palaa takaisin"
    },
    cancel: {
        id: "Peruuta",
        defaultMessage: "Peruuta"
    },
    confirm: {
        id: "Poista",
        defaultMessage: "Poista"
    },
    somethingWentWrong: {
        id: "Tapahtui virhe. Ole hyvä ja yritä uudelleen.",
        defaultMessage: "Tapahtui virhe. Ole hyvä ja yritä uudelleen."
    }
});

const DeleteConnectedEmailModal = (props) => {
    const [showError, setShowError] = useState(false);
    const [loading, setLoading] = useState(false);
    const { userAccountDelete, userGetAccounts } = useUserAccount();
    const lng = props.intl.formatMessage;

    const handleHide = () => {
        props.onHide();
    }

    const handleConfirm = async () => {
        setShowError(false);
        setLoading(true);
        try {
            await userAccountDelete(props.account.username);
            await userGetAccounts(true);
            handleHide();
        } catch (error) {
            setShowError(true);
        } finally {
            setLoading(false);
        }
    }

    if (!props.account) {
        return null;
    }

    return (
        <Modal show={props.show} onHide={handleHide} id='close-account-modal'>
            <Modal.Header closeButton>
                <Button
                    disabled={loading}
                    className="modal-back"
                    onClick={handleHide}
                    aria-label={lng(messages.goBack)}
                >
                    <FontAwesomeIcon icon={far.faArrowLeft} aria-hidden="true" /> {lng(messages.goBack)}
                </Button>
                <Modal.Title>{lng(messages.title)}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {showError && (
                    <AlertDialog
                        type="danger"
                        message={lng(messages.somethingWentWrong)}
                    />
                )}
                <p>
                    {lng(messages.confirmationText).replace('%email%', props.account.email)}
                </p>
                <div className="d-flex gap-3 mt-4">
                    <Button disabled={loading} variant='primary' onClick={handleConfirm}>
                        {loading && (<Spinner animation="border" size="sm" />)} {lng(messages.confirm)}
                    </Button>
                    <Button disabled={loading} variant='secondary' onClick={handleHide}>
                        {lng(messages.cancel)}
                    </Button>
                </div>
            </Modal.Body>
        </Modal>
    );
};

DeleteConnectedEmailModal.propTypes = {
    intl: PropTypes.object.isRequired,
    show: PropTypes.bool,
    onHide: PropTypes.func,
    account: PropTypes.object
};

export default injectIntl(DeleteConnectedEmailModal);
